module.exports = __webpack_public_path__ + "img/Procurement.df73661d.jpg";